export default function PageNotFound() {
  return (
    <div className="h-full bg-cc-secondary text-cc-secondary-contrast inset-0 p-4 text-center flex flex-col items-center justify-center">
      <h1 className="font-medium text-cc-300 3xs:text-cc-400 xs:text-cc-500 sm:text-cc-600 mb-8">Oops.</h1>
      <h3 className="font-medium text-cc-100 3xs:text-cc-200 xs:text-cc-300 sm:text-cc-400 mb-8">The page you are requesting does not seem to exist.</h3>
      <h4 className="font-medium text-cc-body-medium 3xs:text-cc-body-large">Go back to <a href="/" className="text-cc-link decoration-none">Partner Finder</a>.</h4>
    </div>
  );
}
